import { render, staticRenderFns } from "./ShortCode.vue?vue&type=template&id=013d6350&scoped=true&lang=pug"
import script from "./ShortCode.vue?vue&type=script&lang=js"
export * from "./ShortCode.vue?vue&type=script&lang=js"
import style0 from "./ShortCode.vue?vue&type=style&index=0&id=013d6350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d6350",
  null
  
)

export default component.exports